import React, { useEffect, useState, useCallback } from 'react';
import PouchDB from 'pouchdb-browser';
import PouchdbFind from 'pouchdb-find';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import './DownloadedGroups.css';
import DownloadedElement from '../downloaded_element/DownloadedElement';
import { toast } from 'react-toastify';
import { confirmAlert } from 'react-confirm-alert';
//import { closeMenu } from '../functions/functions';
import EmptyList from '../downloaded_list/Empty';

const DownloadedGroups = () => {
  const { t, i18n } = useTranslation();
  PouchDB.plugin(PouchdbFind);
  const [db, setdb] = useState(PouchDB('gestor_contenidos_db'));
  const [, setdb_agrupaciones] = useState(
    PouchDB('gestor_contenidos_agrupaciones')
  );
  const [datos, setData] = useState([]);
  const [down, setDown] = useState(false);
  const [query_search, setQuerySearch] = useState('');
  const [search, setSearch] = useState('');
  const [is_type, setIsType] = useState(true);
  const [inSearch, setInSearch] = useState(false);
  const [numRes, setNumRes] = useState(0);

  const submit = (object_id, nombre) => {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className="custom-ui">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">{t('modal_eliminar_titulo')}</h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                  onClick={onClose}
                >
                  <span aria-hidden="true">
                    <i className="fal fa-times"> </i>
                  </span>
                </button>
              </div>
              <div className="modal-body">
                {t('modal_eliminar_mensaje')} <strong>"{nombre}"</strong> ?
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary waves-effect waves-themed"
                  onClick={onClose}
                >
                  {t('modal_eliminar_cancelar')}
                </button>
                <button
                  type="button"
                  className="btn btn-danger waves-effect waves-themed"
                  onClick={() => {
                    deleteObject_groups(object_id, 'gestor_contenidos_db');
                    deleteObject_groups(
                      object_id,
                      'gestor_contenidos_agrupaciones'
                    );
                    onClose();
                  }}
                >
                  {t('modal_eliminar_borrar')}
                </button>
              </div>
            </div>
          </div>
        );
      }
    });
  };

  const get_dl_groups = useCallback(() => {
    db.createIndex({
      index: { fields: ['date_downloaded', 'object.group_type'] }
    }).then(result => {
      db.find({
        selector: {
          'object.group_type': { $ne: null },
          date_downloaded: { $gt: null }
        },
        sort: [{ date_downloaded: 'desc' }]
      })
        .then(res => {
          setIsType(res.docs.length);
          setData(res.docs);
          res.docs.length === 0 ? setDown(false) : setDown(true);
        })
        .catch(err => {
          console.log(err);
        });
    });
  }, [db, setIsType, setData, setDown]);

  const get_group_type = group_type => {
    switch (group_type) {
      case 'Agregación':
        return db
          .find({
            selector: {
              'object.group_type': { $eq: 'Agregación' },
              date_downloaded: { $gt: null }
            },
            sort: [{ date_downloaded: 'desc' }]
          })
          .then(res => {
            setIsType(res.docs.length);
            setData(res.docs);
          })
          .catch(err => {});

      case 'Destilación':
        return db
          .find({
            selector: {
              'object.group_type': { $eq: 'Destilación' }
            }
          })
          .then(res => {
            setIsType(res.docs.length);
            setData(res.docs);
          })
          .catch(err => {});

      case 'Cronología':
        return db
          .find({
            selector: {
              'object.group_type': { $eq: 'Cronología' }
            }
          })
          .then(res => {
            setIsType(res.docs.length);
            setData(res.docs);
          })
          .catch(err => {});

      case 'all':
        return db
          .find({
            selector: {
              'object.group_type': { $ne: null },
              date_downloaded: { $gt: null }
            },
            sort: [{ date_downloaded: 'desc' }]
          })
          .then(res => {
            setIsType(res.docs.length);
            setData(res.docs);
          })
          .catch(err => {
            console.log(err);
          });
      default:
        return null;
    }
  };

  const updateSearch = e => {
    setSearch(e.target.value);
  };

  const deleteObjetcData = object_id => {
    setData(
      datos.filter(function(el) {
        return el.object.id !== object_id;
      })
    );
  };

  const deleteObject_groups = (object_id, db_name) => {
    const database = PouchDB(db_name);
    database
      .get(object_id)
      .then(function(doc) {
        database.remove(doc).then(() => {
          //declaracion
          const tmpDBName = 'tmpdb' + db_name; //db temporal
          const deleteFilter = (doc, req) => !doc._deleted;

          //  limpieza
          //  se elimina una db que pueda haber existido antes
          new PouchDB(tmpDBName)
            .destroy()
            //  se crea una db con el nombre del temporal
            .then(() => Promise.resolve(new PouchDB(tmpDBName)))
            //  se replica cla db con el filtro de que solo lo haga con los recursos no borrados
            .then(
              tmpDB =>
                new Promise((resolve, reject) => {
                  database.replicate
                    .to(tmpDB, { filter: deleteFilter })
                    .on('complete', () => {
                      resolve(tmpDB);
                    })
                    .on('denied', reject)
                    .on('error', reject);
                })
            )
            //  destruir la db
            .then(tmpDB => {
              return database.destroy().then(() => Promise.resolve(tmpDB));
            })
            //  recrear la db original
            .then(
              tmpDB =>
                new Promise((resolve, reject) => {
                  try {
                    resolve({
                      database: new PouchDB(db_name),
                      tmpDB: tmpDB
                    });
                  } catch (e) {
                    reject(e);
                  }
                })
            )
            //  replicar la db temporal a la db original
            .then(
              ({ database, tmpDB }) =>
                new Promise((resolve, reject) => {
                  tmpDB.replicate
                    .to(database)
                    .on('complete', () => {
                      resolve(tmpDB);
                    })
                    .on('denied', reject)
                    .on('error', reject);
                })
            )
            //  destruir la db temporal
            .then(tmpDB => tmpDB.destroy())
            .then(() => {
              if (db_name === 'gestor_contenidos_db') {
                setdb(PouchDB('db_name'));
              } else if (db_name === 'gestor_contenidos_agrupaciones') {
                setdb_agrupaciones(PouchDB('gestor_contenidos_agrupaciones'));
              }
            })
            .catch(err => {
              console.log(err);
            });
        });
      })
      .then(result => {
        deleteObjetcData(object_id);
        toast.dismiss();
        setDown(datos.length - 1);
        toast.success(t('toast_eliminado'));
      })
      .catch(err => {
        toast.dismiss();
        toast.error(t('toast_completar_accion'));
      });
  };

  const findGroup = e => {
    e.preventDefault();
    if (search.length === 0) {
      get_dl_groups();
    } else {
      setQuerySearch(search);
      setInSearch(true);
      let regexp = new RegExp(search, 'i');
      db.find(
        {
          selector: {
            $and: [
              { 'object.general.title.value': { $regex: regexp } },
              { 'object.group_type': { $ne: null } }
            ]
          }
        },
        function(err, res) {
          if (err) {
            // handle error
          } else {
            setData(res.docs);
            setNumRes(res.docs.length);
          }
        }
      );
    }
  };

  useEffect(() => {
    //closeMenu();
    get_dl_groups();
    i18n.changeLanguage(localStorage.getItem('lang'));
  }, [get_dl_groups, i18n]);

  return (
    <div>
      <div
        style={{ backgroundColor: '#FAC600', width: '100%', height: '12px' }}
      >
        {' '}
      </div>

      <ol className="breadcrumb m-0">
        <li className="breadcrumb-item">
          <Link to="/" title={'dashboard'}>
            <i className="fal fa-home"> </i>
            <span> {t('catalogo')}</span>
          </Link>
        </li>

        <li className="breadcrumb-item active">
          <i className="fal fa-archive"> </i>{' '}
          <span className=""> {t('header_agrupaciones')}</span>
        </li>
      </ol>

      <div className="options">
        {down ? (
          <>
            <form onSubmit={findGroup}>
              <div className="input-group input-group-lg mb-5 shadow-1 rounded">
                <input
                  type="text"
                  className="form-control shadow-inset-2"
                  id="busqueda"
                  aria-label="Escribir más de dos letras"
                  placeholder={t('buscar_agrupacione_descargas')}
                  value={search}
                  onChange={updateSearch}
                />
                <div className="input-group-append">
                  <button
                    className="btn btn-default waves-effect waves-themed"
                    type="submit"
                  >
                    <i className="far fa-search mr-lg-2"> </i>
                  </button>
                </div>
              </div>
            </form>

            {inSearch ? (
              <button
                type="button"
                onClick={() => {
                  get_dl_groups();
                  setSearch('');
                  setInSearch(false);
                }}
                title={t('landing_reiniciar_busqueda')}
                className="btn btn-sm btn-default btn-pills waves-effect waves-themed"
              >
                <i className="far fa-redo"> </i>{' '}
                {t('landing_reiniciar_busqueda')}
              </button>
            ) : (
              ''
            )}

            {inSearch ? (
              <h1 className="mb-4 related-resources-title-pwa">
                {' '}
                {numRes} {t('landing_resultados_encontrados')}
                {"'" + query_search + "'"}
              </h1>
            ) : (
              ''
            )}

            {!inSearch ? (
              <ul className="nav nav-pills" role="tablist" id="dld-groups">
                <li className="nav-item" onClick={() => get_group_type('all')}>
                  <a
                    className="nav-link active"
                    data-toggle="tab"
                    href="#js_pill_border_icon-1"
                  >
                    <i className="fal fa-check mr-1"> </i>
                    {t('todas')}
                  </a>
                </li>
                <li
                  className="nav-item"
                  onClick={() => get_group_type('Agregación')}
                >
                  <a
                    className="nav-link"
                    data-toggle="tab"
                    href="#js_pill_border_icon-2"
                  >
                    <i className="fal fa-list-alt mr-1"> </i>
                    {t('agregacion')}
                  </a>
                </li>
                <li
                  className="nav-item"
                  onClick={() => get_group_type('Destilación')}
                >
                  <a
                    className="nav-link"
                    data-toggle="tab"
                    href="#js_pill_border_icon-3"
                  >
                    <i className="fal fa-list-ol mr-1"> </i>
                    {t('destilacion')}
                  </a>
                </li>
                <li
                  className="nav-item"
                  onClick={() => get_group_type('Cronología')}
                >
                  <a
                    className="nav-link"
                    data-toggle="tab"
                    href="#js_pill_border_icon-4"
                  >
                    <i className="fal fa-clock mr-1"> </i>
                    {t('cronologia')}
                  </a>
                </li>
              </ul>
            ) : (
              ''
            )}

            <div
              id="js_list_accordion"
              className="accordion accordion-hover accordion-clean js-list-filter mt-5"
            >
              {is_type
                ? ''
                : !inSearch && (
                    <div
                      className="alert border-info bg-transparent text-info"
                      role="alert"
                    >
                      <strong>Info!</strong> {t('no_tipo_agrupacion')}
                    </div>
                  )}

              {datos.map(elemento => (
                <DownloadedElement
                  key={elemento.object.id}
                  type={'group'}
                  id={elemento.object.id}
                  nombre={elemento.object['general'].title.value}
                  description={elemento.object['general'].description[0].value}
                  deleteObject={() =>
                    submit(
                      elemento.object.id,
                      elemento.object['general'].title.value
                    )
                  }
                />
              ))}
            </div>
          </>
        ) : (
          <EmptyList
            message={t('empty_para_descarga_agrupaciones')}
            c_message={t('empty_no_descargas_agrupaciones')}
          />
        )}
      </div>
    </div>
  );
};

export default DownloadedGroups;
